module.exports = __webpack_public_path__ + "img/team-2.edaa63d0.jpg";